import PropTypes from 'prop-types';
import { createCompose, skip, skipAll } from 'react-xocs/dist/xocs/xocs-core';
import join from 'react-xocs/dist/lib/join';
import math from 'react-xocs/dist/math/';
import XocsType from '../xocsType';

const xocs = {
  title: skip,
  subtitle: skip,
  footnote: skipAll,
  'cross-ref': skipAll,
  math,
};

const isTitle = e => e['#name'] === 'title';
const isSubtitle = e => e['#name'] === 'subtitle';

export default function Title({
  content,
}) {
  const variables = { assetCdnUrl: window.config.assetCdnUrl };
  const compose = createCompose(xocs, undefined, variables);

  const fullTitle = content
    .filter(e => isTitle(e) || isSubtitle(e))
    .map(compose);

  return (join(fullTitle, ': '));
}

Title.propTypes = {
  content: PropTypes.arrayOf(XocsType),
};
